import SsgMain from './main';

SsgMain.install = function(Vue) {
  Vue.component(SsgMain.name, SsgMain);
};

export default SsgMain;